import React, { useState, useMemo } from "react";

const ContextErrorNetwork = React.createContext<any>(null);
export const useCheckLoading = () => React.useContext(ContextErrorNetwork);
const ProvidersCheckLoading = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);

  const value = useMemo(() => {
    return {
      isLoading,
      setIsLoading,
    };
  }, [isLoading, setIsLoading]);
  return (
    <ContextErrorNetwork.Provider value={value}>
      {children}
    </ContextErrorNetwork.Provider>
  );
};
export default ProvidersCheckLoading;